export const SHOPIFY_ATTACH_PARAM = "shopify_attach"
/** Dashboard entry that attaches the pending install to the signed-in account (sign-in form first if needed). */
export const SHOPIFY_ATTACH_URL = `/?${SHOPIFY_ATTACH_PARAM}=1`
